var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDownward(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 14.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_downward") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.07,29.11A1.51,1.51,0,0,1,21,28.67l-12-11.89a1.5,1.5,0,1,1,2.12-2.13l12,11.9a1.5,1.5,0,0,1-1.06,2.56Z",
    transform: "translate(-8.61 -14.21)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1,29.11a1.5,1.5,0,0,1-1.05-2.57l12-11.85a1.5,1.5,0,0,1,2.11,2.14l-12,11.85A1.56,1.56,0,0,1,22.1,29.11Z",
    transform: "translate(-8.61 -14.21)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownward);
export default __webpack_public_path__ + "static/media/ic_downward.217bb2fc2acb0ba072d1b67247eeaa31.svg";
export { ForwardRef as ReactComponent };